import type { ReactNode } from 'react';
import { ErrorState } from './ErrorState';

export interface PageStateProps {
  isLoading: boolean;
  error: unknown;
  /** Заголовок ошибки загрузки. */
  errorTitle: ReactNode;
  onRetry?: () => void;
  retrying?: boolean;
  /** Скелетон на время загрузки. */
  skeleton: ReactNode;
  isEmpty?: boolean;
  empty?: ReactNode;
  children: ReactNode;
}

/** Общий выбор состояния экрана/блока: загрузка → ошибка → пусто → данные. */
export function PageState({
  isLoading,
  error,
  errorTitle,
  onRetry,
  retrying,
  skeleton,
  isEmpty = false,
  empty = null,
  children,
}: PageStateProps) {
  if (isLoading) return <>{skeleton}</>;
  if (error)
    return <ErrorState title={errorTitle} error={error} onRetry={onRetry} retrying={retrying} />;
  if (isEmpty) return <>{empty}</>;
  return <>{children}</>;
}
